export var size0 = "0px";
export var size50 = "2px";
export var size100 = "4px";
export var size200 = "8px";
export var size300 = "12px";
export var size400 = "16px";
export var size500 = "24px";
export var size600 = "32px";
export var size700 = "40px";
export var size800 = "48px";
export var size900 = "64px";
export var size1000 = "96px";
export var size1100 = "128px";